import { ComponentPropsWithoutRef, FC } from 'react';

export type LogoutIconProps = ComponentPropsWithoutRef<'svg'>;

export const LogoutIcon: FC<LogoutIconProps> = ({ fill, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            {...props}
        >
            <path
                d="M1.8387 13.4592C1.49084 13.4592 1.19492 13.3372 0.95095 13.0932C0.706977 12.8493 0.584991 12.5527 0.584991 12.2036V1.8006C0.584991 1.45148 0.706977 1.15493 0.95095 0.910956C1.19492 0.666984 1.49084 0.544998 1.8387 0.544998H7.02487V1.54417H1.8406C1.77648 1.54417 1.71772 1.57088 1.6643 1.62431C1.61087 1.67773 1.58416 1.73649 1.58416 1.8006V12.2036C1.58416 12.2677 1.61087 12.3265 1.6643 12.3799C1.71772 12.4333 1.77648 12.46 1.8406 12.46H7.02487V13.4592H1.8387ZM10.6755 9.73964L9.93758 9.05937L11.4953 7.50169H5.13064V6.50252H11.4953L9.93758 4.94483L10.6755 4.26056L13.4151 7.0001L10.6755 9.73964Z"
                fill={fill ?? 'currentColor'}
            />
        </svg>
    );
};
